import CityPageTemplate from "../city-template/CityPageTemplate";
import { louisvilleCoConfig } from "./data";

export default function LouisvilleCoPage() {
  return <CityPageTemplate config={louisvilleCoConfig} />;
}